"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptMarketingSubscription = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const acceptMarketingSubscription = exports.acceptMarketingSubscription = (0, _actionGenerator.actionGenerator)(_types.EAgreementActionTypes.MarketingSubscriptionAccepted);